// Chakra imports
import {
  Button,
  Flex,
  FormControl,
  GridItem,
  SimpleGrid,
  Text,
  Textarea,
  useColorModeValue,
} from "@chakra-ui/react";
import Card from "components/card/Card";
import PopOverAlert from "components/popAlert/popAlert";

import {
  alterarProtocolo,
  atualizarProtocolo,
  enviaEmailAtendimento,
  pesquisarProtocoloComentario,
} from "config/apis/requests";
import { IsEmpty } from "config/functions";
import { useEffect, useState } from "react";

export default function Information(props: {
  dataUser: any;
  cpfBusca: any;
  protocolo: any;
  clienteProtocolo: any;
  ticketGerado: any;
}) {
  const { dataUser, protocolo, ticketGerado } = props;
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const [ticket, setTicket] = useState([]);
  const [loadingFinalizar, setLoadingFinalizar] = useState(false);
  const [loadingEncaminhar, setLoadingEncaminhar] = useState(false);
  const [statusPopOver, setStatusPopOver] = useState("warning");
  const [titlePopOver, setTitlePopOver] = useState("Ops...");
  const [subtitlePopOver, setSubtitlePopOver] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenAlert = (status: boolean) => {
    setIsOpen(status);
  };

  const showPopOver = (status: string, title: string, subtitle: string) => {
    handleOpenAlert(true);
    setStatusPopOver(status);
    setTitlePopOver(title);
    setSubtitlePopOver(subtitle);
  };

  const [observacao, setObservacao] = useState("");

  const finalizarAtendimento = () => {
    showPopOver("success", "Atendimento", "Atendimento encerrado com sucesso!");
    setTimeout(() => {
      window.scrollTo(0, 0);
      window.location.href = "/atendimento#/admin/dashboard";
    }, 2000);
  };

  const encaminharAtendimento = () => {
    setLoadingEncaminhar(true);
    const bodyDeskAtualizacao = {
      id: !IsEmpty(protocolo) ? protocolo.id : ticketGerado,
      subject:
        "Chamado encaminhado " + protocolo.id ??
        "Chamado encaminhado " + ticketGerado,
      description: decodeURI(observacao),
      requesterName: dataUser.nome,
      requesterEmail: dataUser.email,
    };

    const bodyCriacaoChamado = {
      idChamado: !IsEmpty(protocolo) ? protocolo.id : ticketGerado,
      nome: dataUser.nome,
      email: dataUser.email,
    };

    enviaEmailAtendimento(bodyCriacaoChamado).then(function (result: any) {
      if (!IsEmpty(result.status)) {
        if (result.status >= 400) {
          showPopOver("error", "Ops...", "Erro ao enviar email!");
        }
      }
    });

    atualizarProtocolo(bodyDeskAtualizacao).then(function (result) {
      setTicket(result);
      // cadastrarProtocoloComentario(protocolo.id ?? result.id, observacao);
      showPopOver(
        "success",
        "Atendimento",
        "Atendimento encaminhado com sucesso!"
      );
      setTimeout(() => {
        window.scrollTo(0, 0);
        window.location.href = "/atendimento#/admin/dashboard";
      }, 2000);
    });
    setLoadingEncaminhar(false);
  };

  useEffect(() => {
    if (!IsEmpty(protocolo)) {
      pesquisarProtocoloComentario(protocolo.id).then(function (result) {
        setObservacao(result[0]?.body);
      });
    }
  }, [protocolo, dataUser, ticket]);

  const handleInputChange = (e: any) => {
    const inputValue = e.target.value;
    setObservacao(inputValue);
  };

  return (
    <>
      <PopOverAlert
        handleOpenAlert={handleOpenAlert}
        isOpen={isOpen}
        status={statusPopOver}
        title={titlePopOver}
        subtitle={subtitlePopOver}
      />
      <FormControl>
        <Card mb="20px" {...dataUser}>
          <Flex direction="column" mb="30px" ms="10px">
            <Text fontSize="xl" color={textColorPrimary} fontWeight="bold">
              Observações do atendimento
            </Text>
          </Flex>
          <SimpleGrid
            columns={1}
            spacing={{ base: "20px", xl: "20px" }}
          >
            <Textarea
              placeholder="Escreva um breve resumo sobre o atendimento do usuário"
              value={observacao}
              onChange={(e) => handleInputChange(e)}
            />
            <GridItem alignContent="flex-end">
              <Flex direction={{ base: "column", md: "row" }} gap="10px" justifyContent={"space-between"}>
                <Button
                  w={{ base: "100%", md: "263px" }}
                  colorScheme="brand"
                  mr={1}
                  onClick={finalizarAtendimento}
                  isLoading={loadingFinalizar}
                  disabled={
                    IsEmpty(dataUser) && IsEmpty(observacao) ? true : false
                  }
                >
                  Finalizar atendimento
                </Button>
                {/* <Button
                w={"263px"}
                colorScheme="brand"
                mr={1}
                onClick={encaminharAtendimento}
                isLoading={loadingEncaminhar}
                disabled={
                  IsEmpty(dataUser) || IsEmpty(observacao) ? true : false
                }>
                Encaminhar atendimento
              </Button> */}
              </Flex>
            </GridItem>
          </SimpleGrid>
        </Card>
      </FormControl>
    </>
  );
}
